// extracted by mini-css-extract-plugin
export default {"cls1":"QhrtZ7IvBJXgevRRr0yc","cls2":"NVrI2N_A5fUPFqL2Jnh8 QhrtZ7IvBJXgevRRr0yc","loading":"S7z_HyMMEZVyjbv1qXD_","isPhone":"VcnlAEnCUDA5DCuR2vta"};